import {Box, Grid, Statistic} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import {renderWithoutParagraphs} from '../../utils'
import type {TextItem} from '../../types'
import baseStyles from '../../styles/base.module.css'
import styles from './FlexSuiteStatistics.module.css'

type Props = {
  stats?: TextItem[]
}

export function FlexSuiteStatistics({stats}: Props) {
  if (!stats?.length) return null

  const hasFourStats = stats.length === 4
  const desktopColumnCount = hasFourStats ? 4 : 3

  return (
    <Box className={baseStyles.cardGridFrame}>
      <Box className={styles.statsGridContent}>
        <Grid columnGap="none" rowGap="none" enableGutters={false} className={baseStyles.gridContent}>
          {stats.map((stat, index) => {
            const startsTabletRow = hasFourStats && index >= 2
            const endsTabletRow = hasFourStats && ((index + 1) % 2 === 0 || index === stats.length - 1)
            const startsDesktopRow = index >= desktopColumnCount
            const endsDesktopRow = (index + 1) % desktopColumnCount === 0 || index === stats.length - 1

            return (
              <Grid.Column
                key={stat.sys.id}
                span={{xsmall: 12, medium: hasFourStats ? 6 : 12, large: hasFourStats ? 3 : 4}}
              >
                <Box
                  padding={{narrow: 32, wide: 48}}
                  borderColor="muted"
                  borderStyle="solid"
                  borderBlockStartWidth={index === 0 ? 'none' : 'thin'}
                  borderInlineStartWidth="thin"
                  borderInlineEndWidth="thin"
                  className={clsx(styles.statsGridItem, {
                    [styles.fourColumnGridItem]: hasFourStats,
                    [styles.tabletRowStart]: startsTabletRow,
                    [styles.tabletRowEnd]: endsTabletRow,
                    [styles.desktopRowStart]: startsDesktopRow,
                    [styles.desktopRowEnd]: endsDesktopRow,
                  })}
                >
                  <Statistic>
                    <Statistic.Heading
                      font="monospace"
                      weight="normal"
                      size="700"
                      style={{color: 'var(--brand-color-accent-primary)'}}
                    >
                      {renderWithoutParagraphs(stat.fields.heading)}
                    </Statistic.Heading>
                    <Statistic.Description font="monospace" size="100">
                      {renderWithoutParagraphs(stat.fields.description)}
                    </Statistic.Description>
                  </Statistic>
                </Box>
              </Grid.Column>
            )
          })}
        </Grid>
      </Box>
    </Box>
  )
}
